/* eslint-disable @typescript-eslint/default-param-last */
import { combineReducers } from 'redux';

import * as types from './types';

export const initState = {};

initState.byID = {};
export const byID = (state = initState.byID, { type, payload }) => {
  switch (type) {
    case types.FETCH_EMPLOYEES.SUCCESS:
      return {
        ...state,
        ...payload.reduce(
          (emps, emp) => ({
            ...emps,
            [emp.employeeID]: emp,
          }),
          {},
        ),
      };
    case types.FETCH_CURRENT_EMPLOYEE.SUCCESS:
      return { ...state, [payload.employeeID]: payload };
    case types.SAVE_EMPLOYEE.SUCCESS:
      return {
        ...state,
        [payload.employeeID]: { ...payload, id: Number(payload.employeeID) },
      };
    case types.SAVE_USER.SUCCESS:
      return {
        ...state,
        [payload.employeeID]: {
          ...state[payload.employeeID],
          userID: payload.userID,
        },
      };
    case types.DELETE_EMPLOYEE.SUCCESS:
      // eslint-disable-next-line no-case-declarations
      const afterDelete = { ...state };
      delete afterDelete[payload];
      return afterDelete;
    default:
      return state;
  }
};

export const userRights = (state = { modules: [] }, { type, payload }) => {
  switch (type) {
    case types.SET_USER_RIGHTS.SUCCESS:
      return payload;
    default:
      return state;
  }
};

initState.loading = false;
export const loading = (state = false, { type }) => {
  switch (type) {
    case types.FETCH_CURRENT_EMPLOYEE.START:
    case types.FETCH_EMPLOYEES.START:
    case types.SET_USER_RIGHTS.START:
      return true;
    case types.FETCH_CURRENT_EMPLOYEE.SUCCESS:
    case types.FETCH_CURRENT_EMPLOYEE.ERROR:
    case types.FETCH_EMPLOYEES.SUCCESS:
    case types.FETCH_EMPLOYEES.ERROR:
    case types.SET_USER_RIGHTS.SUCCESS:
    case types.SET_USER_RIGHTS.ERROR:
      return false;
    default:
      return state;
  }
};

initState.userGroups = [];
export const userGroups = (state = initState.userGroups, { type, payload }) => {
  switch (type) {
    case types.FETCH_USER_GROUPS.SUCCESS:
      return payload;
    default:
      return state;
  }
};

export default combineReducers({ byID, userGroups, loading, userRights });
